import { AvailableAmenity } from 'models/Amenity';
import { AvailableRule } from 'models/Rule';

export const canEditAmenity = (amenity: AvailableAmenity | AvailableRule) => {
  const { supportsDescription } = amenity;
  const supportsPrice = 'supportsPrice' in amenity && amenity.supportsPrice;
  const supportsChargeFrequencies =
    'supportedChargeFrequencies' in amenity &&
    amenity.supportedChargeFrequencies.length > 1;

  return supportsDescription || supportsPrice || supportsChargeFrequencies;
};
